import _ from "lodash";
// import zh from '../../i18n/zh';
// import en from '../../i18n/en';
import { compareAscDate, isValidDateRange } from "../../utils/date";


//設定 placeholder 的語系
// export const handleFormattedMessage = (id, language) => {
//   let messages;
//   if (language.includes("en") || language === "ENGLISH") {
//     messages = en[id];
//   } else {
//     messages = zh[id];
//   }
//   return messages;
// }

// excel檔名不能有 [ ] < > : * ? | 
export const checkExcelNaming = (name) => {
  return name.replace(/\[|]|<|>|:|\*|\?|\|/g, "");
}

// 檢查email格式
export const checkEmail = (email) => {
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return isValidEmail.test(email);
}

export const checkAddressesIsNull = (toAddresses) => {
  return !toAddresses || toAddresses.includes("example@gmail.com") || (Array.isArray(toAddresses) && toAddresses.length === 1 && toAddresses[0] === "");
}

export const CREATE_FIELDS_FORMAT = [
  {
    id: 'createFields.label.format.number',
    value: 'DEFAULT',
    name: '數字'
  },
  {
    id: 'createFields.label.format.percentage',
    value: 'PERCENT',
    name: '百分比'
  },
  {
    id: 'createFields.label.format.amount',
    value: 'TWD',
    name: '金額($)'
  },
]

export const INPUT_ERROR_MSG = {
  reportName: null,
  fbAdAccounts: null,
  dateRange: null,
  email: null,
  emailTemplate: null,
  optionFieldName: null,
  reportType: null,
  selectFields: null,
  excelSheet: null,
}

export const DOWNLOAD_ERROR_MSG = {
  reportName: null,
  fbAdAccounts: null,
  optionFieldName: null,
  reportDateRange: null,
  selectFields: null,
  excelSheet: null,
}

export const SEND_ALL_ERROR_MSG = {
  reportDateRange: null,
  toAddresses: null,
  report_mode: null,
}

export const FORM_DATA_ALL = {
  weeklyReportName: "",
  startSendDate: null,
  endSendDate: null,
  sendDay: 1,
  sendTime: "08:00",
  monthly: 1,
  reportType: 0,
  facebookAdAccountIds: null,
  toAddresses: null,
  mailMessageType: "REACH_LINK_CLICK",
  mailMessageExtra: null,
  excelSheets: ["LINE_DAILY", "LINE_CREATIVE", "LINE_AUDIENCE", "LINE_GENDER", "LINE_AGE"],
  fields: null,
  startReportDate: null,
  endReportDate: null,
  campaignList: null,
  language: "CHINESE",
  conversionsType: "conversions"
}

// 搜尋關鍵字清除[]符號
export const cleanSearchKeyword = (text) => {
  // 刪除多個[]及其內部文字，保留前後文字
  const matches = text.match(/\[.*?\]/g);
  if (matches && matches.length > 0) {
    let cleanedText = text;
    matches.forEach(match => {
      cleanedText = cleanedText.replace(match, '');
    });
    return cleanedText.trim();
  }

  // 沒有多個[]時，去除[]，保留內部文字
  return text.replace(/[\[\]]/g, '').trim();
}

export const checkDateRangeForm = (date) => {
  if (!date.startReportDate || !date.endReportDate) {
    return 'createData.modal.download.errorMsg.enterDate';
  }
  if (compareAscDate(date.startReportDate, date.endReportDate) > 0) {
    return 'createData.modal.download.errorMsg.afterEndDate';
  }
  return '';
}

// 確認是否設定過廣告活動
export const checkSetUpCampaigns = (value) => {
  return !(Array.isArray(value) && value.length === 1 && value[0] === 'all');
}

// 表單驗證
const commonValidations = {
  reportName: (value) => !value ? 'createData.reportName.placeholder' : null,
  fbAdAccounts: (value) => (!value || !value.length) ? 'createData.account.placeholder' : null,
  excelSheet: (value) => (!value || !value.length) ? 'createData.tab.errorMsg.excel' : null,
  selectFields: (fields) => (!fields || !fields.length) ? 'createData.field.errorMsg.pleaseEnter' : null,
  optionFieldName: (fields) => {
    if (!fields || !fields.length) return null;
    const removeRepeatFieldName = _.uniqBy(fields, 'name');
    return fields.length !== removeRepeatFieldName.length ? 'createData.field.errorMsg.duplicated' : null;
  },
}

const emailValidations = {
  reportType: (sendTimeData) => {
    return !sendTimeData.reportType?.length ? 'sendTime.sendType.errorMsg' : null;
  },
  // email: (emailList) => !emailList?.length || emailList[0] === 'example@gmail.com' ? 'emailData.recipient.errorMsg.empty' : null,
};

const campaignGoalsValidations = (value) => {
  return (!value || !value.length) ? 'createData.tab.errorMsg.target' : null;
}

const mediaSpecificValidations = {
  FACEBOOK: {
  },
  TABOOLA: {
  },
  GOOGLE: {
    optionFieldName: () => null,
  },
  LINE: {
    campaignGoalsSelected: campaignGoalsValidations,
  },
}

const validateForm = (data, validations, isDownload, media) => {
  const errorMsg = {};
  let isTab1Error = false;
  let isTab2Error = false;
  let isErrorStatue = false;

  Object.entries(validations).forEach(([key, validateFn]) => {
    if (key === 'reportType' && isDownload) {
      return;
    }

    const error = validateFn(data[key]);
    if (error) {
      errorMsg[key] = error;
      if (Object.keys(commonValidations).includes(key)) {
        isTab1Error = true;
      } else if (Object.keys(mediaSpecificValidations[media]).includes(key)) {
        isTab1Error = true;
      } else if (Object.keys(emailValidations).includes(key)) {
        isTab2Error = true;
      }
    }
  });

  if (errorMsg && Object.keys(errorMsg).length && errorMsg.constructor === Object) {
    isErrorStatue = true;
  }

  return { isTab1Error, isTab2Error, errorMsg, isErrorStatue };
}

export const checkReportForm = (data, media) => {
  const { isDownload, ...formData } = data;
  const validations = { ...commonValidations, ...emailValidations, ...(mediaSpecificValidations[media] || {}) };
  return validateForm(formData, validations, isDownload, media);
}